import computeClassName from '../../../utils/computeClassName';
import SocialLinks from './SocialLinks';
import Copyrights from './Copyrights';
import ResourcesAndLegalLinks from './ResourcesAndLegalLinks';
import QuickLinks from './QuickLinks';

const constants = Object.freeze( {
  CLASSNAME_BASE: 'block py-cc-4 px-12 md:px-20 bg-cc-secondary text-cc-secondary-contrast',
} );

export default function MasterFooter({ className = ''}) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  return (
      <footer className={computedClassName}>
        <div className="w-full">
          <div className="pt-5 pb-cc-4.5 flex items-center justify-start xs:justify-center lg:justify-between border-b-2 border-cc-muted">
            <QuickLinks className="text-left xs:text-center lg:text-left"/>
            <SocialLinks className="text-center hidden lg:block"/>
          </div>
          <ResourcesAndLegalLinks className="mt-cc-2.5 mb-cc-2 lg:mb-5 text-left xs:text-center lg:text-left"/>
          <SocialLinks className="border-t-2 border-cc-muted pt-cc-5.5 mb-cc-5.5 text-center block lg:hidden"/>
          <Copyrights className="pb-5 text-center lg:text-left"/>
        </div>
      </footer>
  );

}

//
